import { ThemeContext } from '../../context/ThemeContext';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import './FauluLoanCalculator.scss';
import OmButton from '../forms/OmButton';
import { createStructuredSelector } from 'reselect';
import { formatCurrency, getCurrencyCodeSelector } from '../currencies';

import { Fragment } from 'react';
import { OmApplicationPopupModal, OmCalculatorResult, OmIcon, OmLoader, OmModal, OmRadioButtonGroup } from '@om/component-library-react';
import OmInputFieldWrapper from '../forms/OmInputFieldWrapperError';
import { getAccessToken, getApiCallStatus, getDuration, getDurationValue, getFormStatusValid, getInterestValue, getIsExpiredAuth, getLoanAmountValue, getRepaymentDurationValue, getResultValue, getUgCmbObject } from '@om/redux/selectors/fauluLoanCalculator/fauluLoanCalculator';
import { apiTransitionFauluLoan, reInitialize, setComputeLoanValue, setDurationValue, setExpiredAuth, setInterestValue, setLoanAmountValue, setRepaymentDurationValue, setSideBarOpen } from '@om/redux/actions/fauluLoanCalculator/fauluLoanCalculatorForm';
import debounce from 'lodash.debounce';
import { collectLoginDetails } from '@om/redux/actions/fauluLoanCalculator/auth';
import { setLeadSystem } from '@om/redux/actions/publicWeb/callMeBack';

const FauluLoanCalculator = ({ twoColumnImageLeftContent, tableContent, isInContainer, onCompleteEvent, slot }) => {

    let dispatch = useDispatch();
    const theme = React.useContext(ThemeContext);

    function openCallMeBackForm() {
        dispatch(setSideBarOpen(true));
        dispatch(setLeadSystem('ke-faulu'));
    }

    useEffect(() => {
        dispatch(collectLoginDetails());
    }, []);

    const {
            duration,
            amount,
            interest,
            repaymentDuration,
            formStatus,
            selectedDuration,
            apiCallStatus,
            result,
            ugCmbObject,
            isTokenExpired
        } = useSelector(
            createStructuredSelector({
                duration: getDuration,
                amount: getLoanAmountValue,
                interest: getInterestValue,
                repaymentDuration: getRepaymentDurationValue,
                formStatus: getFormStatusValid,
                selectedDuration: getDurationValue,
                apiCallStatus: getApiCallStatus,
                result: getResultValue,
                auth: getAccessToken,
                ugCmbObject: getUgCmbObject,
                isTokenExpired: getIsExpiredAuth,
            })
        );

    const formattedPresentValue = result ? formatCurrency(result?.loanCalculation.monthlyAmount, 'KES') : 0;
    const formattedWhatYouWillNeed = result ? formatCurrency(result?.loanCalculation.totalAmount, 'KES') : 0;  

    const debounced = debounce(function() {
        dispatch(setComputeLoanValue());
    },500);
   
    const reuthenticateUser = () => {
        dispatch(collectLoginDetails());
        dispatch(setExpiredAuth(false))
    }

    return (
        <div className={`faulu-loan-calculator ${isInContainer ? 'container-full-width' : ''} ${theme}`} slot={slot}>
            <div className="form-wrapper">
                <div className="form-content">      
                    <OmInputFieldWrapper
                        id="loan-amount-to-borrow"
                        size="full"
                        label="How much do you want to borrow?"
                        labelAlwaysShow={true}
                        mask="thousands-spaced"
                        keyboardMode="numeric"
                        validatorType="number"
                        align="left"
                        placeholder={`Loan Amount (KES)`}
                        reduxValue={amount}
                        persistHandler={ (e) => dispatch(setLoanAmountValue(e))}
                        errorMessage='Please enter the loan amount in figures'
                    />
                
                    <OmInputFieldWrapper
                        id="loan-repayment-time"
                        size="full"
                        mask="number"
                        keyboardMode="numeric"
                        validatorType="number"
                        label="How long will you need to repay the loan?"
                        labelAlwaysShow={true}
                        align="left"
                        placeholder={`Loan Duration (Months/Years)`}
                        reduxValue={repaymentDuration}
                        persistHandler={ (e) => dispatch(setRepaymentDurationValue(e))}
                         errorMessage='Please enter the loan duration in figures'
                    />
                    
                    
                    <OmRadioButtonGroup
                        slot="radio-inputs"
                        groupName="duration"
                        vertical="true"
                        value={selectedDuration.value}
                        onOnSelection={(event) => {   
                            dispatch(setDurationValue(event.detail));
                        }}
                    >
                        <ul>
                            {duration.map((entry, index) => {
                                return (
                                    <li key={index} value={entry.value}>
                                        {entry.description}
                                    </li>
                                );
                            })}
                        </ul>
                    </OmRadioButtonGroup>
                
                    <OmInputFieldWrapper
                        id="loan-annual-interest"
                        size="full"
                        mask="number"
                        keyboardMode="numeric"
                        validatorType="number"
                        align="left"
                        label="How much interest will  you pay each year?"
                        labelAlwaysShow={true}
                        placeholder={`Annual interest rate(%)`}
                        reduxValue={interest}
                        persistHandler={(e) => {
                            dispatch(setInterestValue(e))
                        }}
                        errorMessage='Please enter the loan interest in figures'
                    />
                </div>
                <div>
                    <div className='call-to-action'>
                        <div>
                            <h6 slot="end-heading">
                                <strong>Ready to apply for your loan?</strong>
                            </h6>
                            <div slot="end-text">
                                <p >
                                    Get a personal loan of up to KES 6,000,000 and flexible monthly payments. It’s quick and easy.
                                </p>
                                <h6 className='sms-text'>SMS 'LOAN' TO 22506, and we will get back to you within 24 hours.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="button-result-wrapper">

                <div className="button-wrapper">
                    <OmButton
                        slot="button"
                        type="primary"
                        size="small"
                        text="CALCULATE"
                        iconName="arrow_forward"
                        withIcon={true}
                        disabled={formStatus}
                        onClick={ () => debounced() }
                    />
                    <p slot="button-disclaimer">
                        <span>Have any queries? </span>
                        <span><b>Call </b>+254 711 074 000,</span>
                        <span><b>Email </b>info@faulukenya.com, or</span>
                        <span><b>WhatsApp </b>+ 254 708 000 111.</span>
                    </p>
                    <p><OmLoader isLoading={apiCallStatus === 'pending'} /> </p>
                </div>

                <div className="result-wrapper">
                    <div slot="result">
                        { result ? (
                            <OmCalculatorResult>
                                <h6 slot="row-1-col-1" className="no-bottom-margin no-top-margin">
                                    <strong>Your Total Loan Repayment</strong>
                                </h6>
                                <h6 slot="row-1-col-2" className="no-bottom-margin no-top-margin">
                                    <strong>{formattedWhatYouWillNeed}</strong>
                                </h6>

                                <div slot="row-2-col-1">
                                    <p className="no-bottom-margin no-top-margin">Your monthly repayment will be</p>
                                    <h5 className="no-bottom-margin no-top-margin">
                                        <strong>{formattedPresentValue}</strong>
                                    </h5>
                                </div>

                                <div slot="row-2-col-2">
                                    <OmButton
                                        slot="recalculate-mobile"
                                        type="secondary"
                                        size="small"
                                        text="RESET CALCULATOR"
                                        withIcon={false}
                                        onClick={ () => dispatch(reInitialize())}
                                    />
                                </div>

                                { true && (
                                    <Fragment>
                                        <h6 slot="end-heading">
                                            <strong>Ready to apply for your loan?</strong>
                                        </h6>
                                        <div slot="end-text">
                                            <p >
                                                Get a personal loan of up to KES 6,000,000 and flexible monthly payments. It’s quick and easy.
                                            </p>
                                            <p className='sms-text'>SMS 'LOAN' TO 22506, and we will get back to you within 24 hours.</p>
                                            <span className='text-note'><b>Note:</b> <em>The repayment amount is only an estimate and is subject to a credit check.</em></span>

                                        </div>
                                        
                                    </Fragment>
                                )}

                                {/* <OmButton
                                    slot="end-button"
                                    type="primary"
                                    size="small"
                                    text="REQUEST CALL BACK"
                                    withIcon
                                    iconName="arrow_forward"
                                    actionObject={ugCmbObject}
                                    onClick={() => openCallMeBackForm()}
                                    
                                /> */}
                            </OmCalculatorResult>
                        ) : null }

                        { apiCallStatus === 'failure' && <OmApplicationPopupModal
                                name="Failed request"
                                dismissible="true"
                                exitable="true"
                                open={apiCallStatus === 'failure'}
                                onModalClosed={ (e) => dispatch(apiTransitionFauluLoan.initial())}
                            >
                                <div slot="content" className="payments-error">
                                    <OmIcon image-url="https://oldmutual.co.ke/om-docs/bltdd2d80ffad8f9057/WRONG_CMOS.svg" />
                                    <h5 className="no-bottom-margin">Something looks wrong?</h5>
                                    <h6 className="no-bottom-margin cmos-text">
                                        We are unable to process your request at the moment. Please try again
                                    </h6>
                                </div>
                                <div slot="button">
                                    <OmButton type="primary" size="small" text="Try again" onClick={ (e) => dispatch(apiTransitionFauluLoan.initial())} />
                                </div>
                            </OmApplicationPopupModal>}
                    </div>
                </div>
            </div>
            { isTokenExpired &&  <OmApplicationPopupModal 
                    open={isTokenExpired} 
                    exitable="true" 
                    name="Failed Authentication"
                    dismissible="true"
                    onModalClosed={ (e) => reuthenticateUser()}
                >
                    <div slot="content" className="payments-error">
                        <h5 className="no-bottom-margin">Expired, Session</h5>
                        
                        <h6 className="no-bottom-margin cmos-text">
                            Your session has expired click the button below to reload your session
                        </h6>
                        <div className="cancel-modal-buttons">
                            <OmButton type="primary" text="Reload" size="small" onClick={reuthenticateUser} />
                        </div>
                    </div>
                </OmApplicationPopupModal>
            }
        </div>
    );
};

export default FauluLoanCalculator;
